import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BiChevronDown } from 'react-icons/bi'; // Import necessary icons

// Styled component for the container
// Dark mode styles for DropdownContainer
const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  transition: all ease-in 3s;

  body.dark-mode & {
  }
`;

// Dark mode styles for DropdownButton
const DropdownButton = styled.button`
  background-color: #f4f5f7;
  background: #290078;
  color: #fff;
  width: 242px;
  height: 40px;
  font-weight: 400;
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  border: 1px solid #0d2853;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease-in 0.3s;

  &:hover {
    color: #fff;
    background-color: #290078;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    border-radius: 5px 5px 0px 0px;
  }

  body.dark-mode & {
    background-color: #290078; /* Dark mode background */
    color: #e0e0e0; /* Dark mode text color */
    border: 1px solid #4f4f4f; /* Dark mode border */
  }
`;

// Dark mode styles for DropdownContent
const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #ffffff;
  min-width: 98%;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.2s ease, visibility 0.2s ease;

  ${DropdownContainer}:hover & {
    display: block;
    opacity: 1;
  }

  body.dark-mode & {
    background-color: #1b1b3a; /* Darker background for dark mode */
  }
`;

// Dark mode styles for DropdownItem
const DropdownItem = styled.div`
  color: #1b2559;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  justify-content: center;

  &:hover {
    background-color: #e0e0e0; // Lighter grey for hover
  }

  body.dark-mode & {
    color: #e0e0e0; /* Light text for dark mode */
    &:hover {
      background-color: #4a4a4a; /* Darker hover effect */
    }
  }
`;


const CustomDropdown = ({ label, options, onChange, value }) => {
  const selectedOption = options.find(option => option.value === value);


  const displayLabel = selectedOption ? `${label} : ${selectedOption.label}` : label;  // Using Unicode for dropdown symbol
  return (
    <DropdownContainer>
      <DropdownButton>
        {displayLabel}
        {selectedOption ? null : <BiChevronDown />}
      </DropdownButton>
      <DropdownContent>
  {options.map((option, index) => (
    <DropdownItem
      key={index}
      onClick={() => {
        if (option.value === 'HR') {
          onChange({ target: { value: option.value } });
        }
      }}
      style={{
        cursor: option.value !== 'HR' ? 'not-allowed' : 'pointer',  // Block cursor for non-HR options
        opacity: option.value !== 'HR' ? 0.5 : 1,  // Make non-HR options look disabled
        pointerEvents: option.value !== 'HR' ? 'none' : 'auto'  // Prevent click for non-HR options
      }}
    >
      {option.label}
    </DropdownItem>
  ))}
</DropdownContent>
    </DropdownContainer>
  );
};

CustomDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CustomDropdown;
